import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListGrammarCheckpointHistoryV1Response } from './list-grammar-checkpoint-history-v1-response';
import { listGrammarCheckpointHistoryV1ResponseSchema } from './list-grammar-checkpoint-history-v1-response';

export async function listGrammarCheckpointHistoryV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListGrammarCheckpointHistoryV1Response>> {
  return getRequest<IListGrammarCheckpointHistoryV1Response>({
    path: '/grammar/checkpoints/v1',
    schema: listGrammarCheckpointHistoryV1ResponseSchema,
    options,
  });
}
